import BlogPage from "@/src/pages/consumer/BlogPage";

import { articlesFromFilenameList } from "@/src/utils/articleSyncHelpers";

import { loadArticleRouteData } from "../articleRouteData";
import { useHydrateArticleAtoms } from "../useHydrateArticleAtoms";
import type { Route } from "./+types/blog";

// Runs at build time (ssr:false + prerender) to render the static listing HTML
// and power the SEO meta tags below with real data.
export async function loader() {
  return loadArticleRouteData();
}

// Runs in the browser for client-side navigations. For the prerendered listing
// the build-time loader data is inlined and returned by `serverLoader()`, so we
// reuse it; otherwise we resolve on the client. Deliberately no
// `hydrate = true` / `HydrateFallback` so the initial render (and `meta()`) use
// the loader data instead of an empty fallback.
export async function clientLoader({ serverLoader }: Route.ClientLoaderArgs) {
  try {
    const serverData = (await serverLoader()) as Awaited<
      ReturnType<typeof loader>
    >;
    if (serverData && Object.keys(serverData.articles).length > 0) {
      return serverData;
    }
  } catch {
    // No prerendered data available; resolve the article list on the client.
  }

  return loadArticleRouteData();
}

export const meta: Route.MetaFunction = ({ loaderData }) => {
  const firstArticle = loaderData
    ? articlesFromFilenameList(
        loaderData.filenames,
        loaderData.filenameToSlug,
        loaderData.articles
      )[0]
    : undefined;
  const firstImage = firstArticle?.mainImage?.url;

  return [
    {
      title: "Baanan autojutut - ajankohtaisia juttuja auton myynnistä - Baana"
    },
    {
      name: "description",
      content:
        "Baanan autojutut-osiosta löydät ajankohtaisia ja mielenkiintoisia juttuja auton myyntiin liittyen. Tervetuloa automyynnin ohituskaistalle Baanaan!"
    },
    { property: "og:title", content: "Baanan autojutut - Baana" },
    {
      property: "og:description",
      content:
        "Baanan autojutut-osiosta löydät ajankohtaisia ja mielenkiintoisia juttuja auton myyntiin liittyen."
    },
    ...(firstImage ? [{ property: "og:image", content: firstImage }] : []),
    { property: "og:type", content: "website" },
    { tagName: "link", rel: "canonical", href: "/blog" }
  ];
};

export default function BlogRoute({ loaderData }: Route.ComponentProps) {
  useHydrateArticleAtoms(loaderData);

  return <BlogPage />;
}
